export class BNLSearchPage {
	init() {
		const url = new URL(window.location.href);
		let searchValue = url.searchParams.get("searchTerm");
		if (searchValue && location.hash === "") { // If coming from search icon in header, load that to update the location hash
			searchValue = searchValue.replace("%20", " ");
			const searchInputs = document.querySelectorAll<HTMLInputElement>(".st-default-search-input");
			searchInputs.forEach(searchInput => {
				searchInput.value = searchValue ?? "";
			});
			this.UpdateHash(searchValue ?? "");
		}
	}

	private UpdateHash(searchValue: string) {
		location.hash = "stq=" + searchValue + "&stp=1";
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const searchPage = new BNLSearchPage();
	searchPage.init();
});
